function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.371 9.204A.622.622 0 0016.907 9H7.66a.622.622 0 00-.465.204.676.676 0 00-.196.484c0 .187.065.348.196.484l4.623 4.818a.625.625 0 00.465.205.622.622 0 00.464-.205l4.623-4.818a.676.676 0 00.196-.484.677.677 0 00-.196-.484z"
});

function SvgPimp(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24"
  }, props), _ref);
}

export default SvgPimp;